import { Dispatch } from "redux";
import axios from "axios";

import { ActionType } from "../action-types";
import {
  Action,
  SetOperatorAction,
  SetRolesAction,
  SetTwilioAuthAction,
} from "../actions";
import { OperatorDto, PostLoginAction } from "../../dto/postLogin";
import { RolesDto, RolesResponse } from "../../dto/roles";
import { http } from "../../utils/http";
import { AppThunk } from "./types";

export const login = (token: string) => {
  return (dispatch: Dispatch<Action>): void => {
    dispatch({ type: ActionType.LOGIN, payload: token });
  };
};

export const logout = () => {
  return (dispatch: Dispatch<Action>): void => {
    dispatch({ type: ActionType.LOGOUT });
  };
};

export const setTwilioAuth = (
  token: string,
  identity: string
): SetTwilioAuthAction => ({
  type: ActionType.SET_TWILIO_AUTH,
  payload: { token, identity },
});

export const setOperator = (operator: OperatorDto): SetOperatorAction => ({
  type: ActionType.SET_OPERATOR,
  payload: operator,
});

export const setRoles = (roles: RolesDto[]): SetRolesAction => ({
  type: ActionType.SET_ROLES,
  payload: roles,
});

export const updateTimeFormat = (on: boolean) => {
  on
    ? localStorage.setItem("use24hTimeFormat", "true")
    : localStorage.removeItem("use24hTimeFormat");

  return (dispatch: Dispatch<Action>): void => {
    dispatch({
      type: ActionType.UPDATE_TIME_FORMAT,
      payload: on,
    });
  };
};

export const updateLocal = (local: string) => {
  localStorage.setItem("local", local);
  return (dispatch: Dispatch<Action>): void => {
    dispatch({
      type: ActionType.UPDATE_LOCAL,
      payload: local,
    });
  };
};

export const postApiToken =
  (): AppThunk<Promise<PostLoginAction>> => async (dispatch, getState) => {
    const jwt = getState().token;
    if (!jwt) throw new Error("Missing JWT!");

    try {
      const [tokenRes, operatorRes, roles] = await Promise.all([
        http.post("/api/Token", null),
        http.get("/api/Operators/me"),
        http.get("/api/Roles"),
      ]);

      const tokenData = tokenRes.data;
      const operatorData = operatorRes.data as OperatorDto;
      const rolesData = roles.data as RolesResponse;

      dispatch(setOperator(operatorData));
      dispatch(setRoles(rolesData.roles));
      dispatch(setTwilioAuth(tokenData.token, tokenData.identity));

      return {
        ...tokenData,
        operator: operatorData,
        roles: rolesData,
      };
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const status = error.response?.status ?? "NO_STATUS";
        const text =
          typeof error.response?.data === "string"
            ? error.response.data
            : JSON.stringify(error.response?.data ?? "");
        throw new Error(`POST /api/Token failed REQUEST: ${status} ${text}`);
      }
      throw error;
    }
  };
